module.exports = __webpack_public_path__ + "static/img/montecarlo.a078364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/montecarlo.jpg
// module id = GeeW
// module chunks = 1